/* eslint camelcase: 0 */
import moment from 'moment-timezone'
import { Options } from '@/infrastructure/network/Legacy/schema'
import { IOptionsProps, EmptyOptionsPropsFactory } from '@/entities/Legacy/Options'

export const toOptionsProps = (props: Options): IOptionsProps => {
  if (!props) {
    return EmptyOptionsPropsFactory()
  }

  const { now, total, page, take, count, search, relation, hospital, tabs, started, ended, sort, desc, conditions } = props
  return {
    now: now ? moment(now).utc().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss') : '',
    total,
    page,
    itemsPerPage: take,
    pageCount: count,
    sortBy: [sort],
    sortDesc: [desc],
    search,
    relation: relation ? relation.map((props) => Number(props)) : [],
    conditions: conditions ? JSON.parse(conditions) : undefined,
    hospital,
    tabs,
    started: started ? moment(started).format('YYYY-MM-DD HH:mm:ss Z') : '',
    ended: ended ? moment(ended).format('YYYY-MM-DD HH:mm:ss Z') : ''
  }
}
